import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

export default () => (
    <Card>
        <CardHeader title={"Buna " + localStorage.getItem('name') + ". Bine ati venit in panoul de administrare!"} />
        <CardContent>Aici puteti vedea date despre masinile detinute, si administra rezervarile dumneavoastra.</CardContent>
    </Card>
);